<template>
  <div class="container-fluid">
    <h2 class="dtb-title"></h2>
    <div class="mt-4">
      <h3>Curso</h3>
      <table class="table">
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Lecciones</th>
            <th>Calificaciones</th>
            <th>Certificado</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="modulo in modulos"
            :key="modulo.id"
            style="background-color: white"
          >
            <td>
              {{ modulo.nombre }}
              <button
                class="btn btn-danger btn-sm ms-2"
                @click="irLeccion(modulo.id, modulo.primera_leccion_id)"
              >
                Ingresar
              </button>
            </td>
            <td>{{ modulo.cantidad_lecciones }}</td>
            <td>{{ obtenerCalificacion(modulo.id) }}</td>
            <td>{{ obtenerCertificacion(modulo.id) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <Preloader :visible="cargando" />
  </div>
</template>

<script>
import CalificacionService from "../../services/CalificacionService";
import CertificadoService from "../../services/CertificadoService";
import ModuloService from "../../services/ModuloService";
import Preloader from "../components/Preloader.vue";

export default {
  name: "Modulo",
  data() {
    return {
      modulos: [],
      id_curso: this.$route.params.id_curso,
      calificaciones: {},
      certificados: {},
      cursoNombre: "",
      id_cliente: "",
      user: JSON.parse(localStorage.getItem("user")),
    };
  },
  components: {
    Preloader,
  },
  created() {
    this.fetchModulos(this.id_curso);
  },

  methods: {
    async llamarCalificacion(id_modulo) {
      try {
        const response =
          await CalificacionService.getCalificacionporModulodeUsuario(
            id_modulo,
            this.user.id
          );
        this.calificaciones[id_modulo] = response.data.data[0].calificacion;
      } catch (error) {
        console.error("Error fetching calificación", error);
      }
    },

    async llamarCertificado(id_modulo) {
      try {
        const response =
          await CertificadoService.getCertificadoporModulodeUsuario(
            id_modulo,
            this.user.id
          );
        this.certificados[id_modulo] = response.data.data[0].id;
      } catch (error) {
        console.error("Error fetching calificación", error);
      }
    },

    obtenerCalificacion(id_modulo) {
      return this.calificaciones[id_modulo] || "Sin calificación";
    },
    obtenerCertificacion(id_modulo) {
      return this.certificados[id_modulo] || "Sin calificación";
    },

    async fetchModulos(id_curso) {
      try {
        this.cargando = true;
        const response = await ModuloService.getModulosporCurso(id_curso);
        this.modulos = response.data.data;

        for (const modulo of this.modulos) {
          this.llamarCalificacion(modulo.id);
          this.llamarCertificado(modulo.id);
        }
      } catch (error) {
        console.error("Error fetching Modulos", error);
        this.$swal({
          icon: "error",
          title: "Error",
          text: "Hubo un error al cargar los módulos.",
        });
      } finally {
        this.cargando = false;
      }
    },

    irLeccion(id_m, id_l) {
      this.$router.push({
        name: "Leccion",
        params: {
          idcurso: this.id_curso,
          idmodulo: id_m,
          idleccion: id_l,
        },
      });
    },
  },
};
</script>

<style scoped></style>
